import * as React from 'react';
import { useNavigate, useSearchParams } from 'react-router-dom';

import { LinearProgress } from '@mui/material';

import { useSnackbar } from 'notistack';

import { useCreateNewCabinEvent } from '../../core/api/hooks/cabin-event';
import { useAuthorizedFormData } from '../../core/context/AuthorizedFormDataContext';

import { CabinEventReport, FlightEventFlightDetailsLookup, FlightLookup } from '../../core/api/clients';

import FlightLookupForm from '../../components/FlightLookupForm';
import FormPaper from '../../components/FormPaper';
import CabinEventNewOptions from './CabinEventNewOptions';

function CabinEventFormNew() {
  const { enqueueSnackbar } = useSnackbar();
  const [isSubmit, setIsSubmit] = React.useState<boolean>(false);
  const [cssCreate, setCssCreate] = React.useState<boolean>(false);
  const navigate = useNavigate();
  const [searchParams] = useSearchParams();

  const [flightSegments, setFlightSegments] = React.useState<CabinEventReport[]>([]);

  const authorizedFormData = useAuthorizedFormData();
  const { mutate: createCabinEvent, status: createCabinEventStatus } = useCreateNewCabinEvent();

  const handleCreateCabinEvent = (eventDetailsLookup: FlightEventFlightDetailsLookup) => {
    createCabinEvent(eventDetailsLookup, {
      onSuccess: (cabinEventReports: CabinEventReport[]) => {
        if (cabinEventReports.length === 1) {
          navigate(`${authorizedFormData.metadata?.route}/${cabinEventReports[0].id}/edit`, { replace: true });
        } else {
          setFlightSegments(cabinEventReports);
        }
      },
      onError: () => enqueueSnackbar('Flight not found', {
        variant: 'warning',
      }),
    });
  };

  React.useEffect(() => {
    if (searchParams.has('cssLegId')) {
      const cssLegId = searchParams.get('cssLegId');
      if (cssLegId !== null) {
        setCssCreate(true);
        handleCreateCabinEvent({ cssLegId });
      }
    }
  }, [searchParams]);

  const onSubmit = (flightLookup: FlightLookup) => {
    setIsSubmit(true);
    handleCreateCabinEvent({ flightLookup });
  };
  const onCancel = () => navigate(authorizedFormData.metadata?.route ?? '');
  const onBlank = () => {
    setIsSubmit(false);
    handleCreateCabinEvent({});
  };

  if (cssCreate && createCabinEventStatus === 'pending') {
    return (
      <LinearProgress />
    );
  }

  return (
    <React.Fragment>
      <FlightLookupForm
        onSubmit={onSubmit}
        onCancel={onCancel}
        onBlank={onBlank}
        color={authorizedFormData.metadata?.color}
        loading={isSubmit && createCabinEventStatus === 'pending'}
      />
      <CabinEventNewOptions data={flightSegments} />
    </React.Fragment>
  );
}

export default CabinEventFormNew;
